import { useInjectReducer, useInjectSaga } from "redux-injectors";
import saga from "./saga";
import { reducer } from "./slice";

export default function CreateAccountInjectors() {
  useInjectReducer({ key: "createAccount", reducer });
  useInjectSaga({ key: "createAccount", saga });
  return null;
}
